import script from "./forum_landing.vue?vue&type=script&setup=true&lang=js"
export * from "./forum_landing.vue?vue&type=script&setup=true&lang=js"

import "./forum_landing.vue?vue&type=style&index=0&id=447c08f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447c08f4"]])

export default __exports__